'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _radio = require('./radio.js');

var _radio2 = _interopRequireDefault(_radio);

var _radioGroup = require('./radio-group.js');

var _radioGroup2 = _interopRequireDefault(_radioGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_radio2['default'].Group = _radioGroup2['default'];

exports['default'] = _radio2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-radio/lib/index.js
// module id = 75
// module chunks = 0